function consoleProxy(obj) {
  const methods = ['log' , 'dir', 'time', 'timeEnd', 'trace', 'assert'];

  for (const method of methods) {
    if (!obj[method]) {
      obj[method] = () => {
        return console[method].apply(console, arguments);
      };
    }
  }
}

function createLogger(level) {
  return (msg='', data) => {
    const dataType = Object.prototype.toString.call(data);

    let payload = {
      severity: level,
      message: msg,
      UserAgent: navigator.userAgent,
      service: 'ereader',
      env: process.env.NODE_ENV,
      refId: window._ref_id || '9999'
    };

    if (data && dataType !== '[object Object]') {
      logger.error(`logging data must be an Object but given ${dataType}: "${data}" from "${msg}"`);
    }

    if (data && dataType === '[object Object]') {
      payload = { ...payload, data };
    }

    if (process.env.NODE_ENV === 'development') {
      return console.log(payload);
    }

    _LTracker.push(payload);
  }
}

const spit = () => {
  let obj = {};

  obj.debug = createLogger('DEBUG');
  obj.info = createLogger('INFO');
  obj.warn = createLogger('WARN');
  obj.error = createLogger('ERROR');
  obj.success = createLogger('SUCCESS');

  consoleProxy(obj);

  return obj;
};

window.logger = spit();
